import React from 'react'

import { Icon, Stack, colors } from '@zet/design-system'

import { IPaymentDetails } from '../../api/paymentModes/types'
import PaymentDetailsItem from './paymentDetailsItem'

type Props = {
  paymentDetails: IPaymentDetails
}

const PaymentDetails = (props: Props) => {
  const {
    paymentDetails: { accountNumber, panNo, bankName, ifscCode },
  } = props
  return (
    <Stack className="h-full bg-white pt-3">
      <PaymentDetailsItem
        icon={
          <Icon
            type="IdCardOutlined"
            size={24}
            color={colors.neutral.black100}
          />
        }
        name={'PAN Card'}
        value={panNo}
      />
      <PaymentDetailsItem
        icon={
          <Icon type="BankOutlined" size={24} color={colors.neutral.black100} />
        }
        name={'Bank Name'}
        value={bankName}
      />
      <PaymentDetailsItem
        icon={<></>}
        name={'Account Number'}
        value={accountNumber}
      />
      <PaymentDetailsItem icon={<></>} name={'IFSC Code'} value={ifscCode} />
    </Stack>
  )
}

export default PaymentDetails
